(function() {

    'use strict';

    /**
     * TermsConditions details form
     * @name termsConditionsCtrl
     * @type ItxTermsCmpCtrl
     */
    var TermsCmp = {
        bindings: {
            data: '<',
            termstextnumber: '<',
            termsdata: '<'
        },
        controller: TermsCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'terms.component.html'
    };

    TermsCmpCtrl.$inject = [];

    function TermsCmpCtrl() 
    {
        var _this = this;

        _this.linetermsMessage = _this.data.messages["text"+_this.termstextnumber];
        _this.termsData = _this.termsdata;
    }

    angular.module('itxApp.common')
        .component('terms', TermsCmp);
})();